module.exports = __webpack_public_path__ + "static/img/1046_phase_function_Paper_PointsHejduk_Prediction.b9d6e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1046_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 22bU
// module chunks = 0